import React from 'react'
import HeaderSlider from '../../Modules/HeaderSlider/HeaderSlider'

export default function Header() {
    return (
        <div className=' w-100 '>
            <HeaderSlider />
        </div>
    )
}
